import { RichTextEditor, RichTextEditorProps } from '@mantine/tiptap';
import '@mantine/tiptap/styles.css';

import { ZorroRichTextEditorLink } from './RichTextEditorLink';

type ZorroRichTextEditorProps = Pick<RichTextEditorProps, 'editor'> & {
  hasHeaderControls?: boolean;
  onMouseLeave?: () => void;
};

const ZorroRichTextEditor = ({
  editor,
  hasHeaderControls = false,
  onMouseLeave,
}: ZorroRichTextEditorProps) => {
  return (
    <RichTextEditor editor={editor}>
      <RichTextEditor.Toolbar sticky stickyOffset={60}>
        <RichTextEditor.ControlsGroup>
          <RichTextEditor.Bold />
          <RichTextEditor.Italic />
          <RichTextEditor.Underline />
          <RichTextEditor.Strikethrough />
          <RichTextEditor.ClearFormatting />
          <RichTextEditor.Code />
        </RichTextEditor.ControlsGroup>

        {hasHeaderControls && (
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.H1 />
            <RichTextEditor.H2 />
            <RichTextEditor.H3 />
            <RichTextEditor.H4 />
            <RichTextEditor.H5 />
            <RichTextEditor.H6 />
          </RichTextEditor.ControlsGroup>
        )}

        <RichTextEditor.ControlsGroup>
          <RichTextEditor.Blockquote />
          <RichTextEditor.CodeBlock />
          <RichTextEditor.Hr />
          <RichTextEditor.BulletList />
          <RichTextEditor.OrderedList />
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup>
          <ZorroRichTextEditorLink />
          <RichTextEditor.Unlink />
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup>
          <RichTextEditor.Undo />
          <RichTextEditor.Redo />
        </RichTextEditor.ControlsGroup>
      </RichTextEditor.Toolbar>

      <RichTextEditor.Content onMouseLeave={onMouseLeave} />
    </RichTextEditor>
  );
};

export { ZorroRichTextEditor };
